export interface Theme {
    name: string;
    properties: any;
}

export const light: Theme = {
    name: "light",
    properties: {
        '--themePrimary': '#4F528C',
        '--themeLighterAltForButton' :'#97bbd6',
        '--themeLighterAlt': '#f3f9fd',
        '--themeLighter': '#d0e7f8',
        '--themeLight': '#a9d3f2',
        '--themeTertiary': '#5ca9e5',
        '--themeSecondary': '#1a86d9',
        '--themeDarkAlt': '#006cbe',
        '--themeDark': '#005ba1',
        '--themeDarker': '#004377',
        '--neutralLighterAlt': '#f8f8f8',
        '--neutralLighter': '#f4f4f4',
        '--neutralLight': '#eaeaea',
        '--neutralQuaternaryAlt': '#dadada',
        '--neutralQuaternary': '#d0d0d0',
        '--neutralTertiaryAlt': '#c8c8c8',
        '--neutralTertiary': '#bab8b7',
        '--neutralSecondary': '#a3a2a0',
        '--neutralPrimaryAlt': '#8d8b8a',
        '--neutralPrimary': '#353459',
        '--neutralDark': '#605e5d',
        '--black': '#494847',
        '--white': '#ffffff',
        '--desc-bg': '#f3f9fd',
        '--themePrimaryContrast': '#A0A3D9',
        //'--themeSecondaryContrast': '#D5D7F2',
        '--themeSecondaryContrast': '#F2E2C4',
        '--themeSecondaryAltContrast': '#D9BC85',


        /* Shadows */    
        "--toolbar-shadow": "rgba(0, 0, 0, 0.133) 0px 3.2px 7.2px 0px, rgba(0, 0, 0, 0.11) 0px 0.6px 1.8px 0px",
        "--background-tertiary-shadow": "0 1px 3px 0 rgba(92, 125, 153, 0.5)",
        
    }
};

export const dark: Theme = {
    name: "dark",
    properties: {
        '--themePrimary': '#A0A3D9',
        '--themeLighterAltForButton' :'#d4e5f0',
        '--themeLighterAlt': '#b3d9f4',
        '--themeLighter': '#bcddf5',
        '--themeLight': '#c5e2f6',
        '--themeTertiary': '#cee7f8',
        '--themeSecondary': '#d8ebf9',
        '--themeDarkAlt': '#e1f0fb',
        '--themeDark': '#ebf5fc',
        '--themeDarker': '#f4fafd',
        '--neutralLighterAlt': '#1c1c1c',
        '--neutralLighter': '#252525',
        '--neutralLight': '#343434',
        '--neutralQuaternaryAlt': '#3d3d3d',
        '--neutralQuaternary': '#454545',
        '--neutralTertiaryAlt': '#656565',
        '--neutralTertiary': '#c8c8c8',
        '--neutralSecondary': '#d0d0d0',
        '--neutralPrimaryAlt': '#dadada',
        '--neutralPrimary': '#D5D7F2',
        '--neutralDark': '#f4f4f4',
        '--black': '#f8f8f8',
        '--white': '#111111',
        '--desc-bg': '#1c1c1c',
        '--themePrimaryContrast': '#4F528C',
        '--themeSecondaryContrast': '#D9BC85',
        '--themeSecondaryAltContrast': '#F2E2C4',

        /* Shadows */
        "--toolbar-shadow": "rgba(255, 255, 255, 0.133) 0px 3.2px 7.2px 0px, rgba(255, 255, 255, 0.11) 0px 0.6px 1.8px 0px",                            
        "--background-tertiary-shadow": "0 1px 3px 0 rgba(8, 9, 10, 0.5)"
        
    }

}